import { FC, useRef, useState } from 'react'
import { Input } from 'antd'

import style from './style.m.less'
import { TimeRangePicker, DropdownSelector2 } from '../../../ui'
import { EUserRole, userRoleMap } from '../../../../constants/approval'

const userTypeOptions = [
    { id: EUserRole.All, value: EUserRole.All, text: userRoleMap.get(EUserRole.All) },
    {
        id: EUserRole.UserWithouPA,
        value: EUserRole.UserWithouPA,
        text: userRoleMap.get(EUserRole.UserWithouPA),
    },
    {
        id: EUserRole.Client,
        value: EUserRole.Client,
        text: userRoleMap.get(EUserRole.Client),
    },
    {
        id: EUserRole.GOOwner,
        value: EUserRole.GOOwner,
        text: userRoleMap.get(EUserRole.GOOwner),
    },
    {
        id: EUserRole.TSO,
        value: EUserRole.TSO,
        text: userRoleMap.get(EUserRole.TSO),
    },
]

interface IFilter {
    eventTypesOptions: any
    typeEventId?: number[]
    onChangeEventId: (id: number[]) => void
    nameCreator?: string
    onChangeNameCreator: (name: string) => void
    roleCreator?: number
    onChangeRoleCreator: (role: number) => void
    nameRecipient?: string
    onChangeNameRecipient: (inn: string) => void
    date?: [moment.Moment, moment.Moment] | null
    onChangeDate: (date: [moment.Moment, moment.Moment] | null) => void
}

const Filter: FC<IFilter> = ({
    eventTypesOptions,
    typeEventId,
    onChangeEventId,
    nameCreator,
    onChangeNameCreator,
    roleCreator,
    onChangeRoleCreator,
    nameRecipient,
    onChangeNameRecipient,
    date,
    onChangeDate,
}) => {
    const divBlock: any = useRef(null)
    const marginSpace = 50
    const itemWidth = `${((divBlock?.current?.offsetWidth || 0) - marginSpace) / 5}px`
    const itemStyle = { width: itemWidth }

    const handleChange = (value: number[]) => {
        onChangeEventId(value)
    }

    return (
        <div className={style.filter} ref={divBlock}>
            <div className={style.filterItem}>
                <div className={style.label}>Дата события</div>
                <TimeRangePicker onChange={onChangeDate} value={date || null} />
            </div>
            <div className={style.filterItem}>
                <div className={style.label}>Тип события</div>
                <DropdownSelector2
                    onChange={handleChange}
                    options={eventTypesOptions}
                    customStyle={itemStyle}
                    placeholder={'Все'}
                    allowClear
                    noDefaultValue
                    isMultiple
                    value={typeEventId || []}
                />
            </div>
            <div className={style.filterItem}>
                <div className={style.label}>Исполнитель</div>
                <Input
                    onChange={(event) => onChangeNameCreator(event.target.value)}
                    placeholder="Введите ФИО / название"
                    className={style.input}
                    value={nameCreator || ''}
                />
            </div>
            <div className={style.filterItem}>
                <div className={style.label}>Роль пользователя (исполнителя)</div>
                <DropdownSelector2
                    onChange={onChangeRoleCreator}
                    options={userTypeOptions}
                    customStyle={itemStyle}
                    value={roleCreator || 0}
                />
            </div>
            <div className={style.filterItem}>
                <div className={style.label}>Адресат действия</div>
                <Input
                    onChange={(event) => onChangeNameRecipient(event.target.value)}
                    placeholder="Введите ФИО / название"
                    className={style.input}
                    value={nameRecipient || ''}
                />
            </div>
        </div>
    )
}

export default Filter
